<!-- =========================================================================================
  File Name: AdminSidebar.vue
  Description: Add admin , Update admin - Sidebar component
========================================================================================== -->


<template>
  <vs-sidebar click-not-close position-right parent="body" default-index="1" color="primary" class="add-new-data-sidebar items-no-padding" spacer v-model="isSidebarActiveLocal">
    <div class="mt-6 flex items-center justify-between px-6">
        <h4>{{ $t("THRESHOLDE_MANAGEMENT") }} </h4>
        <feather-icon icon="XIcon" @click.stop="isSidebarActiveLocal = false" class="cursor-pointer"></feather-icon>
    </div>
    <vs-divider class="mb-0"></vs-divider>

    <VuePerfectScrollbar class="scroll-area--data-list-add-new" :settings="settings">
      <div class="p-6" v-if="serverMonitoringLimit">
        <!-- THRESHOLD -->
        <!-- CPU Load-->
        <div class="vx-col w-full sm:w-auto detail-list" >
          <small>{{$t('CPU_LOAD')}}
            <feather-icon icon="EditIcon" svgClasses="w-5 h-5 hover:text-primary stroke-current" @click.stop="editData('CPU_LOAD', serverMonitoringLimit.cpuLoad)" class="edit-icon" /> 
          </small>
          <p  class="font-semibold text-lg text-right"> {{serverMonitoringLimit.cpuLoad}} % </p>
        </div>
        <!-- Memory Usage -->
        <div class="vx-col w-full sm:w-auto detail-list">
          <small>{{$t('MEMORY_USAGE')}}
            <feather-icon icon="EditIcon" svgClasses="w-5 h-5 hover:text-primary stroke-current" @click.stop="editData('MEMORY_USAGE', serverMonitoringLimit.memoryUsage)" class="edit-icon" /> 
          </small>
          <p  class="font-semibold text-lg text-right"> {{serverMonitoringLimit.memoryUsage}} % </p>
        </div>
        <!-- I/O Throughput -->
        <div class="vx-col w-full sm:w-auto detail-list">
          <small>{{$t('IO_THROUGHPUT')}}
            <feather-icon icon="EditIcon" svgClasses="w-5 h-5 hover:text-primary stroke-current" @click.stop="editData('IO_THROUGHPUT', serverMonitoringLimit.ioThroughput)" class="edit-icon" /> 
          </small>
          <p  class="font-semibold text-lg text-right"> {{serverMonitoringLimit.ioThroughput}} % </p>
        </div>
        <!-- Disk Usage -->
        <div class="vx-col w-full sm:w-auto detail-list">
          <small>{{$t('DISK_USAGE')}}
            <feather-icon icon="EditIcon" svgClasses="w-5 h-5 hover:text-primary stroke-current" @click.stop="editData('DISK_USAGE', serverMonitoringLimit.diskUsage)" class="edit-icon" /> 
          </small>
          <p  class="font-semibold text-lg text-right"> {{serverMonitoringLimit.diskUsage}} % </p>
        </div>
        <!-- Network Rx-->
        <div class="vx-col w-full sm:w-auto detail-list">
          <small>{{$t('NETWORK_RX')}}
            <feather-icon icon="EditIcon" svgClasses="w-5 h-5 hover:text-primary stroke-current" @click.stop="editData('NETWORK_RX', serverMonitoringLimit.networkRx)" class="edit-icon" /> 
          </small>
          <p  class="font-semibold text-lg text-right"> {{serverMonitoringLimit.networkRx}} MB </p>
        </div>
        <!-- Network Tx-->
        <div class="vx-col w-full sm:w-auto detail-list">
          <small>{{$t('NETWORK_TX')}}
            <feather-icon icon="EditIcon" svgClasses="w-5 h-5 hover:text-primary stroke-current" @click.stop="editData('NETWORK_TX', serverMonitoringLimit.networkTx)" class="edit-icon" /> 
          </small>
          <p  class="font-semibold text-lg text-right"> {{serverMonitoringLimit.networkTx}} MB </p>
        </div>


      </div>
    </VuePerfectScrollbar>

    <vs-popup class="sidebar-popup" classContent="popup-example" :title="setPromptTitle(changeOption)" :active.sync="editPopup">
      <div>
        <vs-input :label="$t(changeOption)" v-model="changeData" class="mt-5 w-full" name="change" v-validate="{required: true}" icon-pack="feather" v-mask="'##'" />
			</div>
      <vs-divider />
      <div class="float-right">
        <vs-button @click="openConfirm()" color="primary" type="filled">{{this.$t('SUBMIT')}}</vs-button>
        <vs-button @click="editPopup=false" color="dark" type="flat">{{this.$t('CANCEL')}}</vs-button>
      </div>

      <vs-popup class="sidebar-popup"  :title="this.$t('CONFIRM')" :active.sync="confirmPopup">
        <p>{{this.$t('SUBMIT_CONFIRM_MESSAGE')}}</p>
        <div class="float-right">
            <vs-button @click="acceptEdit(changeOption)" color="danger" type="filled">{{this.$t('CONFIRM')}}</vs-button>
            <vs-button @click="confirmPopup=false" color="dark" type="flat">{{this.$t('CANCEL')}}</vs-button>
        </div>
      </vs-popup>
    </vs-popup>

    <div class="flex flex-wrap items-center p-6" slot="footer">
      <vs-button  class="mr-10" type="border" color="danger" @click="isSidebarActiveLocal = false">{{$t('CLOSE')}}</vs-button>
    </div>

  </vs-sidebar>
</template>

<script>
import { Validator } from 'vee-validate'
import VuePerfectScrollbar from 'vue-perfect-scrollbar'
import vSelect from 'vue-select'

export default {
  components: {
    VuePerfectScrollbar,
    'v-select': vSelect,
  },
  props: {
    isSidebarActive: {
      type: Boolean,
      required: true
    },
    data: {
      type: Object,
      default: () => {},
    }
  },
  watch: {
    isSidebarActive(val) {
      if (!val) return
      if (Object.entries(this.data).length === 0) {
        this.$validator.reset()
      }
    },

  },
  data() {
    return {

      editPopup: false,
      confirmPopup: false,

      changeOption: "",
      changeData: "",

    settings: { // perfectscrollbar settings
          maxScrollbarLength: 60,
          wheelSpeed: .60,
      },
    }
  },
  computed: {
    isSidebarActiveLocal: {
      get() {
        return this.isSidebarActive
      },
      set(val) {
        if(!val) {
          this.$emit('closeSidebar')
        }
      }
    },
    isFormValid() {
        return !this.errors.any()
    },
    serverMonitoringLimit(){
      return this.$store.state.dataSystem.serverMonitoringLimit
    },
  },
  methods: {
    setPromptTitle(changeOption){
      const locale = this.$i18n.locale;
      if(locale == 'en'){
        return 'EDIT '+this.$t(changeOption)
      } else if (locale == 'ko') {
        return this.$t(changeOption)+' 수정'
      }
    },
    editData(option, data){
      this.changeOption = option
      this.changeData = data
      this.editPopup = true
    },
    openConfirm() {
      this.confirmPopup = true
    },
    acceptEdit(){
      this.$vs.loading()

      let obj = {
        seq: this.serverMonitoringLimit.seq,
        limitName: this.changeOption,
        limitValue: this.changeData
      }
    
      this.$store.dispatch("dataSystem/updateServerMonitoringLimit", obj)
      .then(() => {
        this.$store.dispatch("dataSystem/fetchServerMonitoringLimit")
        .then(()=>{
          this.close()
          this.successAlert(this.$t("SUCCESS"),this.$t("UPDATE_SERVER_MONITORING_LIMIT_SUCCESS"))
        })
      })
      .catch(error => {
        this.close()
        this.errorAlert(this.$t("ERROR"), error.message)
      })
    },
    close(){
      this.confirmPopup = false
      this.editPopup = false
      this.$vs.loading.close()
      this.$emit('closeSidebar')
    }
  },
}
</script>

<style lang="scss" scoped>
.add-new-data-sidebar {
  ::v-deep .vs-sidebar--background {
    z-index: 52004;
  }

  ::v-deep .vs-sidebar {
    z-index: 52004;
    width: 400px;
    max-width: 90vw;

    .img-upload {
      margin-top: 2rem;

      .con-img-upload {
        padding: 0;
      }

      .con-input-upload {
        width: 100%;
        margin: 0;
      }
    }
  }
}

.scroll-area--data-list-add-new {
    height: calc(100% - 4.3rem);
}

.detail-list{
  border-bottom:1px solid rgba(0, 0, 0, 0.1);
  padding: 5px 0;
}

</style>
